import React from "react";
import "../../css/featured.css";
import Navbar from "../../Navbar";
import ExploreMore from "../../ExploreMore";
export const Weakeningrupee = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            Weakening Rupee Raises Uncertainty Over India's Potential Interest
            Rate Cuts.
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/navnews/rupee-vs-doller.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
              Geena Jackson is the Creator and Executive Producer of Bears’ Lair
              TV and the Founder and President of Sparkly Frog Clan Productions
              Inc.
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              A decline in the value of India’s rupee has disrupted expectations
              that the central bank’s new governor will swiftly reduce interest
              rates to boost the country’s struggling economy. The rupee has
              repeatedly hit new lows, with a 0.7% drop against the dollar on
              Monday marking its largest single-day decline in nearly two years.
              This depreciation and its potential impact on inflation have
              shaken the near-unanimous belief among economists that the Reserve
              Bank of India (RBI), led by Governor Sanjay Malhotra, would lower
              the benchmark repo rate from its long-standing level of 6.5% in
              the upcoming monetary policy meeting. The weakening rupee adds to
              challenges for India, which, despite being the world’s
              fastest-growing major economy, faces headwinds. Year-on-year GDP
              growth fell sharply to 5.4% in the quarter ending September, the
              lowest in almost two years, due to reduced government spending,
              softer consumer demand, and weak corporate earnings. Madan
              Sabnavis, chief economist at Bank of Baroda, described the rupee’s
              decline as a serious issue for the new RBI governor, noting that
              it complicates the outlook for a rate cut. “A freefall has
              implications for imported inflation and monetary policy, creating
              a difficult situation,” he said. India’s dependence on imports for
              nearly 90% of its oil consumption makes it particularly
              susceptible to rising crude prices, which surged after new US
              sanctions on Russian producers. Strong US economic data has also
              strengthened the dollar, reducing the likelihood of a Federal
              Reserve rate cut. Persistently high inflation, which has
              diminished the purchasing power of millions of Indian households,
              remains a key concern for the RBI. While headline inflation
              breached the upper 6% limit of the central bank’s target range in
              October due to soaring vegetable prices, it eased to 5.2% in
              December. Governor Malhotra, who assumed office last month,
              expects the economy to recover by 2025. He has signaled the RBI’s
              focus on supporting higher growth after his predecessor,
              Shaktikanta Das, faced criticism for maintaining high borrowing
              costs. “It’s a challenging environment for the new governor,” said
              Trinh Nguyen, an economist at Natixis. She added that India’s
              struggles with a strong dollar are not unique, as other developing
              nations face similar issues. However, Nguyen believes that growth
              will remain a priority despite concerns over the rupee’s rapid
              decline. The RBI has actively intervened to stabilize the
              currency, using nearly $70 billion of its foreign exchange
              reserves since they peaked at $705 billion in September. Some
              economists suggest that the recent lack of aggressive RBI action
              signals a possible policy shift under Malhotra toward a more
              market-driven approach, potentially benefiting exports. The RBI
              has not commented on the matter.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
